module.exports = __webpack_public_path__ + "img/user_no_photo.23ff9d4f.png";